// @see https://orval.dev/guides/custom-axios
import Axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { getIdToken } from './firebase';
import { staticConfig } from '@/config';

export const AXIOS_INSTANCE = Axios.create({
  baseURL: `https://admin.auth.${
    staticConfig.env === 'local' ? 'dev' : staticConfig.env
  }.ai-messenger.app/`,
});

// add a second `options` argument here if you want to pass extra options to each generated query
export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  const source = Axios.CancelToken.source();
  const promise = AXIOS_INSTANCE({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }) => data);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  promise.cancel = () => {
    source.cancel('Query was cancelled');
  };

  return promise;
};

// In some case with react-query and swr you want to be able to override the return error type so you can also do it here like this
export type ErrorType<Error> = AxiosError<Error>;

export type BodyType<BodyData> = BodyData;

AXIOS_INSTANCE.interceptors.request.use(async config => {
  const token = await getIdToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
